'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _primitives = require('../primitives');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var renderField = function renderField(_ref) {
  var mode = _ref.mode,
      Value = _ref.Value,
      Input = _ref.Input,
      Label = _ref.Label,
      Info = _ref.Info,
      Err = _ref.Err;

  if (mode === 'value' || mode === 'display' || mode === 'displayOnly') {
    return _react2.default.createElement(
      _primitives.View,
      null,
      _react2.default.createElement(Label, null),
      _react2.default.createElement(Value, { mode: mode }),
      _react2.default.createElement(Info, null),
      _react2.default.createElement(Err, null)
    );
  } else {
    return _react2.default.createElement(
      _primitives.View,
      null,
      _react2.default.createElement(Label, null),
      _react2.default.createElement(Input, { mode: mode }),
      _react2.default.createElement(Info, null),
      _react2.default.createElement(Err, null)
    );
  }
};

exports.default = renderField;